import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2090a885"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M12 0C14.3936 0 16.533 1.06736 18.002 2.74219C21.4065 3.12586 23.9998 6.08387 24 9.59961C24 13.3703 21.0174 16.5 17.25 16.5H5.4375C2.39496 16.5 0.000103307 13.9752 0 10.9502C0 8.27992 1.86607 5.9992 4.39648 5.50098C5.49749 2.31635 8.4648 0 12 0ZM12 3C9.58355 3 7.51713 4.77076 7.04004 7.19238L6.79395 8.44336L5.51855 8.40137C5.49144 8.40047 5.46432 8.40039 5.4375 8.40039C4.13085 8.40039 3 9.50175 3 10.9502C3.0001 12.3985 4.13091 13.5 5.4375 13.5H17.25C19.2815 13.5 21 11.7936 21 9.59961C20.9998 7.40578 19.2814 5.7002 17.25 5.7002H16.4883L16.0391 5.08496C15.1056 3.80675 13.6376 3 12 3Z" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "cloud-icon",
    width: "24",
    height: "17",
    viewBox: "0 0 24 17",
    style: _normalizeStyle({ fill: _ctx.color })
  }, _hoisted_2, 4))
}